import {API_CASES_EXTRACT_DOWNLOAD_RESPONSE} from './action';

const apiCasesExtractDownloadReducer = (state = {}, action) => {
    switch (action.type) {
        case API_CASES_EXTRACT_DOWNLOAD_RESPONSE:
            return state = {
                ...state,
                apiCasesExtractResponse: action.data
            }
        default: return state
    }
};

export default apiCasesExtractDownloadReducer;